import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import numeral from 'numeral';
import IconMixin from '../mixins/IconMixin';
import {SIZE_SMALL} from '../mixins/IconMixin';

export default createReactClass({
  propTypes: {
    iconSet: ImmutablePropTypes.record.isRequired,
    icons: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ).isRequired,
    iconSetIdsInSubscription: ImmutablePropTypes.listOf(
      PropTypes.number
    ).isRequired,
    canAddIconsToKit: PropTypes.bool.isRequired,
    onRequestToBuy: PropTypes.func.isRequired,
    onRequestToDownload: PropTypes.func.isRequired,
    onRequestToUpgrade: PropTypes.func.isRequired,
  },

  mixins: [IconMixin, ImmutableRenderMixin],

  render() {
    const {iconSet, icons, iconSetIdsInSubscription} = this.props;
    const inSubscription = iconSetIdsInSubscription.includes(iconSet.get('id'));
    const isPremium = iconSet.price > 0;
    const buyOrUpgradeClassName = classnames('btn', 'btn-primary', 'm-xs-l-sm');
    let buyOrUpgrade = null;

    if (inSubscription) {
      if (isPremium) {
        const onDownloadClicked = (event) => {
          event.preventDefault();
          this.props.onRequestToDownload(iconSet);
        };
        buyOrUpgrade = <button onClick={onDownloadClicked} className={buyOrUpgradeClassName}>Download</button>;
      }
    } else {
      if (isPremium) {
        const onBuyClicked = (event) => {
          event.preventDefault();
          this.props.onRequestToBuy(iconSet);
        };
        buyOrUpgrade = <button onClick={onBuyClicked} className={buyOrUpgradeClassName}>Buy {numeral(iconSet.price).format('$0')}</button>;
      } else {
        const onUpgradeClicked = (event) => {
          event.preventDefault();
          this.props.onRequestToUpgrade();
        };
        buyOrUpgrade = <button onClick={onUpgradeClicked} className={buyOrUpgradeClassName}>Upgrade</button>;
      }
    }

    const iconElements = this.renderIcons(icons, SIZE_SMALL);
    const className = classnames('icon-set-preview', {'unavailable': !inSubscription})

    return (
      <div className={className}>
        <div className="gg gg-bottom">
          <div className="gg-col">
            <h2 className="m-xs-a-0" data-role="set-name">{iconSet.name}</h2>
          </div>
          <div className="gg-col text-xs-right">
            <div className="text-muted" data-role="set-details">
              {iconSet.icons.size} icons · {iconSet.optimizedFor} · v{iconSet.version} · by {iconSet.creatorName}

              {buyOrUpgrade}
            </div>
          </div>
        </div>
        <hr />
        <div className="icons">
          {iconElements}
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconSet.js